module.exports = __webpack_public_path__ + "static/b1-anchors2-5dd7817c0f50d50b18b22300a5228838.jpg";